import { faArrowAltCircleRight, faClock } from '@fortawesome/free-regular-svg-icons'
import { faMoneyBill, faVideo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { getCourseDetailApi, UpdateCartApi } from '../../Api/ClientServices'
import Button from '../../Components/Button/Button'
import CourseDetail from '../../Components/CourseDetail/CourseDetail'
import Style from './Course.module.css'
import ReactLoading from 'react-loading';
import { separate } from '../../Utils/Seprate/Seprate'
import { convetor } from '../../Utils/MsTohr/convetor'
import { errorToast, succToast } from '../../Utils/Toast/Toast'
const Course = () => {
    const history=useHistory()
    useEffect(()=>{
        getCourseDetail()
    },[])
    const[courseDetail,setCourseDetail]=useState()
    const getCourseDetail=async()=>{
        const data= await getCourseDetailApi(window.location.pathname.split('/')[2])
        setCourseDetail(data.course)
    }

    const addProductToBasketHandler=()=>{
        let info={
            course_id:window.location.pathname.split('/')[2],
            count:1
        }
        UpdateCartApi(info,(succ)=>{
            if(succ.status===1){
                succToast(succ.message)
            }
            else{
                errorToast(succ.message)
            }
        })
    }
    let loadingHandler=null
    
    if(courseDetail===undefined){
      loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
        <ReactLoading type={'cylon'} color={'#096CCC'} />
      </div>
       
    }

    else{
        loadingHandler=<div className={Style.CourseBodyHolder}>
                            <section className={Style.infoCourse}>
                                <h3> <FontAwesomeIcon icon={faMoneyBill}/> قیمت این دوره : <span> {separate(courseDetail.price)} تومان</span></h3>
                                <hr />
                                <p><FontAwesomeIcon icon={faVideo}/>   تعداد سرفصل های این دوره: {courseDetail.segment.length} </p>
                                <p><FontAwesomeIcon icon={faClock}/>   مدت زمان این دوره: {convetor(courseDetail.duration)} </p>
                                <div className='btnHolder'>
                                    <Button Value={"خرید لایسنس دوره"} ClassBtn={'buyBtn'}  clickhandler={addProductToBasketHandler}/>
                                </div>
                            </section>
                            <CourseDetail data={courseDetail}/>
                        </div>
    }
    return (
        <div className={`pageHolder `} id='course'>
            <div className={Style.HeaderCourse}>
                <p className={Style.courseHeaderTitle}> {courseDetail===undefined?'درحال دریافت':courseDetail.name} <FontAwesomeIcon icon={faArrowAltCircleRight} onClick={() => history.goBack()}/></p>
                
            </div>
            {
                loadingHandler
            }
        </div>
    )
}

export default Course
